/**
 * AP Invoices Demo — fixture store (instance of the shared demo store).
 *
 * THROWAWAY DEMO CODE. See `@/demo/core/create-demo-store`.
 */

import { createDemoStore } from '@/demo/core/create-demo-store';
import { buildApDemoSeed } from './fixture-seed';
import type { ApDemoFixtureState } from './fixture-store.types';

export const apDemoStore = createDemoStore<ApDemoFixtureState>(buildApDemoSeed);

export const getApDemoState = apDemoStore.getState;
export const useApDemoStore = apDemoStore.useStore;
export const updateApDemoState = apDemoStore.update;
export const resetApDemoState = apDemoStore.reset;
export const ApDemoStoreProvider = apDemoStore.StoreProvider;
